/**
 * Initial state for the ecare module.
 *
 * @module store/modules/ecare/state
 */
import { EcareState } from "./types";

const state: EcareState = {
  dashboards: [],
  selectedTab: "dashboard",
  editorVisible: false,
};

export default state;
